import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Testimonial {
  name: string;
  role: string;
  company: string;
  rating: number;
  comment: string;
  image: string;
  alt: string;
  stayDuration: string;
}

export default function GuestTestimonials() {
  const testimonials: Testimonial[] = [
  {
    name: 'Rajesh Kumar',
    role: 'Senior VP Operations',
    company: 'Tech Solutions Inc.',
    rating: 5,
    comment: 'Proximus exceeded all expectations. The proximity to our office and the premium amenities made my 3-month project stay incredibly comfortable. The team went above and beyond to ensure everything was perfect.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_138e07571-1763295086046.png",
    alt: 'Professional Indian businessman in navy suit smiling confidently at camera',
    stayDuration: '3 months'
  },
  {
    name: 'Sarah Mitchell',
    role: 'Consulting Director',
    company: 'Global Consulting Group',
    rating: 5,
    comment: 'As someone who travels frequently for work, I can confidently say Proximus sets the standard for serviced apartments. The attention to detail, from the workspace setup to the concierge service, is exceptional.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1878ed03b-1772524451095.png",
    alt: 'Professional woman with blonde hair in business attire smiling warmly',
    stayDuration: '6 weeks'
  },
  {
    name: 'Amit Patel',
    role: 'Product Manager',
    company: 'Innovation Labs',
    rating: 5,
    comment: 'The perfect blend of home comfort and hotel luxury. Being close to IIM Bangalore for my executive program was crucial, and Proximus delivered on every front. Highly recommend for business travelers.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cf987635-1763295184563.png",
    alt: 'Young Indian professional man with beard in casual business attire',
    stayDuration: '2 months'
  }];


  return (
    <section className="py-20 bg-muted">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl lg:text-5xl font-display font-bold text-primary mb-4">
            What Our Guests Say
          </h2>
          <p className="text-lg text-text-secondary">
            Real experiences from business travelers and extended-stay guests who chose Proximus
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) =>
          <div
            key={index}
            className="bg-white rounded-xl p-8 shadow-subtle hover:shadow-premium transition-all duration-300">

              <div className="flex items-center space-x-4 mb-6">
                <div className="relative w-16 h-16 rounded-full overflow-hidden flex-shrink-0">
                  <AppImage
                  src={testimonial.image}
                  alt={testimonial.alt}
                  className="w-full h-full object-cover" />

                </div>
                <div className="flex-1">
                  <h4 className="font-semibold text-primary">{testimonial.name}</h4>
                  <p className="text-sm text-text-secondary">{testimonial.role}</p>
                  <p className="text-xs text-text-secondary">{testimonial.company}</p>
                </div>
              </div>

              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) =>
              <Icon key={i} name="StarIcon" size={16} variant="solid" className="text-accent" />
              )}
              </div>

              <p className="text-text-secondary mb-4 leading-relaxed">
                &quot;{testimonial.comment}&quot;
              </p>

              <div className="flex items-center space-x-2 text-sm text-text-secondary pt-4 border-t border-border">
                <Icon name="ClockIcon" size={16} className="text-accent" />
                <span>Stayed for {testimonial.stayDuration}</span>
              </div>
            </div>
          )}
        </div>

        <div className="mt-12 text-center">
        </div>
      </div>
    </section>);

}